import createTheme from "@material-ui/core/styles/createTheme";

export const listItemHeight = 46; // default in the material-ui virtualized list example
export const inputHeight = 56; // default in material-ui TextField component, used for skeletons
export const space = 8; // default recommended by material and default in material-ui theme
const paper = "#1d1c1c";

export const appDefaults = {
  headerHeight: space * 10, // 80px
  sidebarWidth: space * 10, // 80px
  footerHeight: space * 7.5, // 60px
  maxContentWidth: 1440, // per design
};

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1800,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        fontWeight: 700,
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        minHeight: space * 4,
      },
      dayLabel: {
        width: space * 3,
        textTransform: "uppercase",
        fontSize: "0.5rem",
      },
    },
    MuiPickersCalendar: {
      transitionContainer: {
        marginTop: space,
        minHeight: space * 18,
      },
    },
    MuiPickersDay: {
      day: {
        width: space * 2.25,
        height: space * 2.25,
        margin: `${space * 0.375}px ${space * 0.625}px`,
      },
    },
    MuiSnackbarContent: {
      root: {
        backgroundColor: paper,
        color: "inherit",
      },
    },
  },
  palette: {
    background: {
      default: "#101010",
      paper,
    },
    primary: {
      main: "#ff9800",
    },
    secondary: {
      main: "#ffd600",
    },
    corporateGreen: {
      main: "#7ab742",
      dark: "#6A9E39",
    },
    error: {
      main: "#d32f2f",
      dark: "#a82424",
    },
    success: {
      main: "#7bb442",
    },
    warning: {
      main: "#ffd600",
    },
    blue: {
      main: "#247afd",
    },
    indeterminateCheckbox: {
      main: "#997000",
    },
    type: "dark",
  },
  typography: {
    fontFamily: [
      "Lato",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});

export default theme;
